export var getUrl = function getUrl(store, url) {
  return store.getState()[url] || {
    status: 'pending'
  };
};